import { useCallback, useEffect, useRef } from "react";
import introJs from "intro.js";
import "intro.js/introjs.css";

const useTour = (steps) => {
  const instanceRef = useRef(null);
  const stepsRef = useRef(steps);
  stepsRef.current = steps;

  useEffect(() => () => {
    if (instanceRef.current) {
      try { instanceRef.current.exit(true); } catch (_e) { /* noop */ }
      instanceRef.current = null;
    }
  }, []);

  return useCallback(() => {
    if (instanceRef.current) {
      try { instanceRef.current.exit(true); } catch (_e) { /* noop */ }
    }
    instanceRef.current = introJs().setOptions({ steps: stepsRef.current });
    instanceRef.current.start();
  }, []);
};

export default useTour;
